var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#494C54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4833 20H21.8166C21.3833 20 20.9666 20.0167 20.5666 20.0667C16.0833 20.45 13.8333 23.1 13.8333 27.9833V34.65C13.8333 41.3167 16.4999 42.6333 21.8166 42.6333H22.4833C22.8499 42.6333 23.3333 42.8833 23.5499 43.1667L25.5499 45.8333C26.4333 47.0167 27.8666 47.0167 28.7499 45.8333L30.7499 43.1667C30.9999 42.8333 31.3999 42.6333 31.8166 42.6333H32.4833C37.3666 42.6333 40.0166 40.4 40.3999 35.9C40.4499 35.5 40.4666 35.0833 40.4666 34.65V27.9833C40.4666 22.6667 37.7999 20 32.4833 20ZM21.3333 33.3333C20.3999 33.3333 19.6666 32.5833 19.6666 31.6667C19.6666 30.75 20.4166 30 21.3333 30C22.2499 30 22.9999 30.75 22.9999 31.6667C22.9999 32.5833 22.2499 33.3333 21.3333 33.3333ZM27.1499 33.3333C26.2166 33.3333 25.4833 32.5833 25.4833 31.6667C25.4833 30.75 26.2333 30 27.1499 30C28.0666 30 28.8166 30.75 28.8166 31.6667C28.8166 32.5833 28.0833 33.3333 27.1499 33.3333ZM32.9833 33.3333C32.0499 33.3333 31.3166 32.5833 31.3166 31.6667C31.3166 30.75 32.0666 30 32.9833 30C33.8999 30 34.6499 30.75 34.6499 31.6667C34.6499 32.5833 33.8999 33.3333 32.9833 33.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1334 21.3163V27.983C47.1334 31.3163 46.1001 33.583 44.0334 34.833C43.5334 35.133 42.9501 34.733 42.9501 34.1497L42.9667 27.983C42.9667 21.3163 39.1501 17.4997 32.4834 17.4997L22.3334 17.5163C21.7501 17.5163 21.3501 16.933 21.6501 16.433C22.9001 14.3663 25.1668 13.333 28.4834 13.333H39.1501C44.4667 13.333 47.1334 15.9997 47.1334 21.3163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.13b97fe2ac2deb5970e61967e39ed657.svg";
export { ForwardRef as ReactComponent };